import { IconButton, PurpleLight } from "@bonusx-global/bx-design-system";
import type { ReactElement } from "react";
import type { FeedbackEnum } from "../../../../../../../enums/feedback.enum";

interface FeedbackButtonProps {
  id: string;
  onClick: (() => void) | undefined;
  feedback: FeedbackEnum | null;
  targetFeedback: FeedbackEnum;
  solidIcon: ReactElement;
  outlinedIcon: ReactElement;
}

export function FeedbackButton({
  id,
  onClick,
  feedback,
  targetFeedback,
  solidIcon,
  outlinedIcon,
}: Readonly<FeedbackButtonProps>): JSX.Element {
  const isActive = feedback === targetFeedback;
  const icon = isActive ? solidIcon : outlinedIcon;

  return (
    <IconButton
      id={id}
      size="medium"
      sx={{ color: PurpleLight.contrastText, backgroundColor: PurpleLight.main }}
      onClick={feedback === null ? onClick : undefined}
    >
      {icon}
    </IconButton>
  );
}
